import * as React from 'react';

import {createIcon} from '@chakra-ui/icons';

export const RouteLineIcon = createIcon({
  displayName: 'RouteLineIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        fill='none'
        stroke='currentColor'
        strokeWidth='2.6'
        strokeLinecap='round'
        d='M5 19h6.5a4 4 0 0 0 0-8h-2a4 4 0 0 1 0-8H14'
      />
      <circle cx='5' cy='19' r='3.2' fill='currentColor' />
      <path fill='currentColor' d='M13.2 0.3 18.6 3l-5.4 2.7V0.3Z' />
    </>
  ),
});
